import { Markdown, MarkdownOptions } from '@mews/framework';
import { Link, SimpleList } from '@optimus-web/core';

const MARKDOWN_OPTIONS: MarkdownOptions = {
    wrapper: 'span',
    overrides: {
        a: {
            component: (props) => <Link {...props} target="_blank" rel="noreferrer noopener" inherit />,
        },
        p: ({ children }) => <p>{children}</p>,
        ul: {
            component: (props) => <SimpleList plain {...props} />,
        },
    },
};

/** Takes in notes/observations that may have markdown links, and renders in-line Links.
 *
 * We only support a subset of markdown is observations that may include links.
 * No other formatting is expected.
 */
export const MarkdownNotes = ({ observations }: { observations: string | undefined | null }) => {
    if (!observations) {
        return null;
    }

    // Markdown links look [like this](mews.com) - so, if there are no links, just return the plain text w/out parsing
    if (!observations.includes('](')) {
        return <span>{observations}</span>;
    }

    return <Markdown content={observations} options={MARKDOWN_OPTIONS} />;
};
